import React from 'react'
import SecHeading from '../../../../constants/SecHeading'
import { PiUserThin } from 'react-icons/pi'
import { Grid } from '@mui/material'
import InputTextBox from '../../../../constants/InputTextBox'
import { ProfileData } from '../../../../helpers/models/Models'
interface ProfileDataDetailsProps {
    ProfileDataDetails: ProfileData | null;
}
const ProfileInfoView: React.FC<ProfileDataDetailsProps> = ({ ProfileDataDetails }) => {
    return (
        <div className='pb-3'>
            <SecHeading icon={<PiUserThin />} type='add' label='Profile Info' />
            <p className="border-t border-slate-300 pt-2 border-dashed"></p>
            <Grid container columnSpacing={3} rowSpacing={1}>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Member SN:' name='spouses_name' type='text' value={ProfileDataDetails?.member_sn || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Member Name:' name='spouses_name' type='text' value={ProfileDataDetails?.mem_name || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Member Name(Nepali):' name='spouses_name' type='text' value={ProfileDataDetails?.mem_name_nep || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Spouse Name:' name='spouses_name' type='text' value={ProfileDataDetails?.spouse_name || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Spouse Name(Nepali):' name='spouses_name' type='text' value={ProfileDataDetails?.spouse_name_nep || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Address:' name='spouses_name' type='text' value={ProfileDataDetails?.add_eng || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Address(Nepali):' name='spouses_name' type='text' value={ProfileDataDetails?.add_nep || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Phone No.:' name='spouses_name' type='text' value={ProfileDataDetails?.phone_no || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Sms Mobile No.:' name='spouses_name' type='text' value={ProfileDataDetails?.sms_mob_no || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Citizenship No:' name='spouses_name' type='text' value={ProfileDataDetails?.ctiz_no || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Citizenship Issue District:' name='spouses_name' type='text' value={ProfileDataDetails?.ctiz_issue_district_name || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Citizenship Issue District:' name='spouses_name' type='text' value={ProfileDataDetails?.gender===1?"Male":ProfileDataDetails?.gender===2?"Female":"Others" || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Date Of Birth:' name='spouses_name' type='text' value={ProfileDataDetails?.dob|| ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Pan No.:' name='spouses_name' type='text' value={ProfileDataDetails?.pan_no|| ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Family Male No.:' name='spouses_name' type='text' value={ProfileDataDetails?.family_male_no|| ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Family Female No.:' name='spouses_name' type='text' value={ProfileDataDetails?.family_female_no|| ""} disabled />
                </Grid>
            </Grid>
        </div>
    )
}

export default ProfileInfoView